import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./TwoSectionsAside.module.scss";

import { Row, Column } from "gatsby-theme-carbon";

function TwoSectionsAside({ children, order, className }) {
  const childrenArray = React.Children.toArray(children);
  const columnsProps = {
    aside: {
      colLg: 3,
      colMd: 2,
      offsetLg: order === "default" ? 0 : 1,
      className: styles.aside,
    },
    content: {
      colLg: 8,
      colMd: 6,
      offsetLg: order === "default" ? 1 : 0,
    },
  };

  const rowClassNames = cx(className, styles[order], styles.container);

  return (
    <Row className={rowClassNames}>
      <Column {...columnsProps[order === "default" ? "aside" : "content"]}>
        {childrenArray[0]}
      </Column>
      <Column {...columnsProps[order === "default" ? "content" : "aside"]}>
        {childrenArray[1]}
      </Column>
    </Row>
  );
}

TwoSectionsAside.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  order: PropTypes.string,
};

TwoSectionsAside.defaultProps = {
  order: "default",
};

export default TwoSectionsAside;
